import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isMobile from 'is-mobile';

const itemClassNames = (columnSize, columnAlign, className) =>
  classnames(
    'table__item',
    `table__item--${columnSize}`,
    `table__item--${columnAlign}`,
    className
  );

const titlesClassNames = (columnAlign, hideMobileTitle) =>
  classnames('table__item__title', `table__item__title--${columnAlign}`, {
    'table__item__title--hide': hideMobileTitle
  });

const TableItem = ({
  children: customFunction,
  columnSize,
  columnAlign,
  field,
  label,
  itemOnClick,
  className,
  hideMobileTitle,
  ...itemArgs
}) => {
  const props = customFunction && { children: customFunction(itemArgs) };
  return (
    <li
      className={itemClassNames(columnSize, columnAlign, className)}
      onClick={e => itemOnClick && itemOnClick(itemArgs, e)}
      role='presentation'
      data-testid='tableItem'
    >
      {isMobile() && (
        <p className={titlesClassNames(columnAlign, hideMobileTitle)}>
          {label}
        </p>
      )}
      {customFunction ? (
        <React.Fragment {...props} />
      ) : (
        <p>{itemArgs[field]}</p>
      )}
    </li>
  );
};

TableItem.defaultProps = {
  columnSize: 'normal',
  columnAlign: 'left',
  itemOnClick: null,
  hideMobileTitle: false
};

TableItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.func
  ]),
  columnSize: PropTypes.string,
  columnAlign: PropTypes.string,
  field: PropTypes.string,
  label: PropTypes.string,
  itemArgs: PropTypes.object,
  itemOnClick: PropTypes.func,
  className: PropTypes.string,
  hideMobileTitle: PropTypes.bool
};

export default TableItem;
